import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NpTooltipDirective, NpTooltipPosition } from '../tooltip/index';
import { Utils } from '../utils';

/**
 * kebabç»ä»¶
 * 
 * <example-url>https://stackblitz.com/edit/angular-vc3q8h?embed=1&file=src/app/app.component.html</example-url>
 */

@Component({
  selector: `np-kebab`,
  templateUrl: 'kebab.html',
  styleUrls: ['kebab.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NpKebab implements OnInit {

  /**ä¼ å¥çéè¦è¿è¡å±ç¤ºçæ°ç»  */
  @Input() data: KebabComponentData;
  /**å¸å±æ ¼å¼ï¼é»è®¤flexå¸å± */
  @Input() display: string = 'flex';
  @Input() position: NpTooltipPosition = 'bottomRight';
  /**
   * ç¹å»åä¸ªitemæ¥æ¶ç¬¦åKebabItem æ ¼å¼çå¯¹è±¡
   *  */
  @Output() onItemClicked = new EventEmitter<{ $event: any, item: KebabItem }>();

  @ViewChild(NpTooltipDirective) dropdownTooltip: NpTooltipDirective;
  itemsInKebab: Array<KebabItem> = [];
  itemsOutKebab: Array<KebabItem> = [];
  isDropdownVisible = false;

  constructor() { }

  ngOnInit(): void {
    this.buildKebabItems();
  }

  onKebabItemClicked($event: any, item: KebabItem, itemInKebab: boolean = false) {
    this.onItemClicked.emit({ $event: $event, item: item });

    if (itemInKebab && this.dropdownTooltip) {
      this.dropdownTooltip.hide();
    }
  }

  private buildKebabItems() {
    if (!this.data || !this.data.items) {
      throw new Error('Invalid data');
    }

    this.data.items.forEach(item => {
      if (item.id === undefined || item.id === null) {
        item.id = Utils.ID();
      }
    });

    if (!this.data.limit) {
      this.itemsOutKebab = this.data.items || [];
      this.itemsInKebab = [];

      return;
    }

    if (this.data.limit > 0 && this.data.items.length > 0) {
      this.data.limit = (this.data.limit > this.data.items.length) ? this.data.items.length : this.data.limit;
      this.itemsOutKebab = this.data.items.slice(0, this.data.items.length - this.data.limit) || [];
      this.itemsInKebab = this.data.items.slice(this.itemsOutKebab.length, this.data.items.length) || [];

      return;
    }
  }
}

/**
 * @ignore
 */
export interface KebabComponentData {
  items: Array<KebabItem>;
  /**If no limit passed in or 0, which means all items out of kebab; 
   * if limit === items.length, which means all items in kebab;
   * otherwise, limit is the count for items in kebab.
   *  */
  limit?: number;
}

export interface KebabItem {
  /**é¡µé¢å±ç¤ºææ¡ï¼å­ç¬¦ä¸²ç±»åï¼å±äºå¿ä¼ åæ° */
  value: string;
  /**å¯èªå·±ä¼ å¥ä¸åçidï¼æ¯æå­ç¬¦ä¸²åæ°å­ï¼å¦æä¸ä¼ å¥ï¼åé»è®¤çæéæºid */
  id?: string | number;
  /**æ¯æä¼ å¥`icon`, `text`, `separator`, é»è®¤`text`*/
  type?: 'text' | 'icon' | 'separator';
  /** æ¯æä¼ å¥é¢è²ï¼éå¿ä¼ ï¼ä¸ä¼ ä½¿ç¨é»è®¤è² */
  color?: string;
}


